import { queryOptions } from '@tanstack/react-query'

import { shipmentsClient } from './shipments.service'

export const priceBreakdownsQueryOptions = (shipmentId: string) =>
  queryOptions({
    queryKey: ['price-breakdowns', shipmentId],
    queryFn: async () => shipmentsClient.getPriceBreakdowns(shipmentId),
  })
